import apiClient from './apiClient';

// ============================================================
// Types — aligned with backend/modules/p9311/models/p9311.go
// ============================================================

/** A single swipe attendance record (read-only view from F910 JOIN F901). */
export interface F910Record {
  f910_01: string;           // Employee code
  f910_02: string | null;    // Attendance date (ISO string)
  f910_11: string;           // Swipe type (Q/S/T/V)
  f910_12: string;           // Card reader code
  f910_13: string;           // Swipe time (HHMMSS)
  f901_32: string;           // Department code
  f901_11: string;           // Employee name
  swipe_type_name: string;   // Chinese label for f910_11
}

/** Query filter parameters (sent as GET query params). */
export interface QueryParams {
  employee_from?: string;
  employee_to?: string;
  date_from?: string;        // YYYY-MM-DD
  date_to?: string;          // YYYY-MM-DD
  department_from?: string;
  department_to?: string;
  page?: number;
  size?: number;
}

/** Paginated query response. */
export interface QueryResponse {
  data: F910Record[];
  total: number;
  page: number;
  size: number;
}

// ============================================================
// API Client
// ============================================================

export const p9311Api = {
  /** Query swipe attendance detail records with filters + pagination. */
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.get<QueryResponse>('/api/p9311', { params });
    return res.data;
  },
};
